export default "__VITE_ASSET__a1eab7dd__"